import apollo from '@/apolloClient'
import {
    CG_GET_ORGAS,
    // CG_GET_STATUS,
    GC_GET_USERS,
    GC_GET_FEREDATIONS
} from '@/graphql/utils'

import browserEventBus from '@/utils/browserEventBus'

export default {
    namespaced: true,
    state:{
        organisationNameList:[],
        statusNameList:[],
        userList: [],
        federationList: [],
        logTypes: []
    },
    getters:{
        getOrgaNameList(state){
            return state.organisationNameList;
        },
        getStatusNameList(state){
            return state.statusNameList;
        },
        getUserList(state){
            return state.userList;
        }
    },
    mutations:{
        SET_ORGA_LIST(state, orgaList){
            state.organisationNameList = orgaList;
        },
        SET_STATUS_LIST(state, statusList){
            if (statusList && Array.isArray(statusList)){
                let filteredArr = statusList.filter(e => e.experienced !== null);
                state.statusNameList = filteredArr;
            }
        },
        SET_USER_LIST(state, userList){
            state.userList = userList;
        },
        SET_FEREDATIONS_LIST(state, fedList){
            state.federationList = fedList
        }
    },
    actions:{
        async initAll({state, dispatch}){
            if (state.organisationNameList.length == 0){
                await dispatch('getOrgas');
            }
            // if (state.statusNameList.length == 0){
            //     await dispatch('getStatus');
            // }
            if (state.userList.length == 0){
                await dispatch('getUsers');
            }
            if (state.federationList.length == 0){
                await dispatch('getFederations')
            }

            // Register callback for user list change
            const refreshUserList = () => {
                dispatch('getUsers')
            }
            browserEventBus.onAdd(browserEventBus.eventCategory.user, refreshUserList)
            browserEventBus.onUpdate(browserEventBus.eventCategory.user, refreshUserList)
            browserEventBus.onDelete(browserEventBus.eventCategory.user, refreshUserList)
        },
        async getOrgas({commit}){
            const response = await apollo.query({
                query: CG_GET_ORGAS
            })
            commit('SET_ORGA_LIST', response.data.organisations);
            return response;
        },
        // async getStatus({commit}){
        //     const response = await apollo.query({
        //         query: CG_GET_STATUS
        //     })
        //     commit('SET_STATUS_LIST', response.data.users_aggregate.nodes);
        //     return response;
        // },
        async getUsers({commit}){
            const response = await apollo.query({
                query: GC_GET_USERS
            })
            commit('SET_USER_LIST', response.data.users);

            return response;
        },
        async getFederations({commit}){
            const response = await apollo.query({
                query: GC_GET_FEREDATIONS
            })
            commit('SET_FEREDATIONS_LIST', response.data.federations);
            return response;
        },
    }
}